;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="d44bc391-7917-4783-b586-6abcf809f665",e._sentryDebugIdIdentifier="sentry-dbid-d44bc391-7917-4783-b586-6abcf809f665")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3340],{

/***/ 37507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./asset-hyperlink.json": 25994,
	"./blockquote.json": 62559,
	"./document.json": 51734,
	"./embedded-asset-block.json": 1220,
	"./embedded-entry-block.json": 72258,
	"./embedded-entry-inline.json": 92204,
	"./embedded-resource-block.json": 20546,
	"./embedded-resource-inline.json": 8242,
	"./entry-hyperlink.json": 6502,
	"./heading-1.json": 92813,
	"./heading-2.json": 45080,
	"./heading-3.json": 86423,
	"./heading-4.json": 34942,
	"./heading-5.json": 95579,
	"./heading-6.json": 50705,
	"./hr.json": 37121,
	"./hyperlink.json": 13165,
	"./list-item.json": 38094,
	"./ordered-list.json": 28122,
	"./paragraph.json": 38986,
	"./resource-hyperlink.json": 3105,
	"./table-cell.json": 79924,
	"./table-header-cell.json": 91787,
	"./table-row.json": 75531,
	"./table.json": 39269,
	"./text.json": 63022,
	"./unordered-list.json": 58500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37507;

/***/ }),

/***/ 99174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ marketingOptIn; },
/* harmony export */   "x": function() { return /* binding */ marketingDoubleOptIn; }
/* harmony export */ });
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21744);

var marketingOptIn = function(params) {
    return utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get("".concat("https://api.petsdeli.de/default", "/marketingOptIn"), {
        params: params
    });
};
var marketingDoubleOptIn = function(params) {
    return utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios.get */ .od.get("".concat("https://api.petsdeli.de/default", "/marketingDoubleOptIn"), {
        params: params
    });
};


/***/ }),

/***/ 4015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _markdown_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49729);
/* harmony import */ var _markdown_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_markdown_module_css__WEBPACK_IMPORTED_MODULE_3__);




var Markdown = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("font-sans text-text-secondary", (_markdown_module_css__WEBPACK_IMPORTED_MODULE_3___default().root), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Markdown);


/***/ }),

/***/ 90200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ribbon_text_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30970);
/* harmony import */ var _ribbon_text_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ribbon_text_module_css__WEBPACK_IMPORTED_MODULE_2__);



/**
 * Component to render text with ribbon through Contentful.
 * Due to the limitation to contentful, using dangerouslySetInnerHTML is the only possible way to archive the request.
 *
 * @example
 * // text value
 * Wir sind <span class="arrow-highlight pink">Problemlöser</span>
 *
 * @TODO : implementation is duplicated with RibbonText component
 */ var RibbonText = function(param) {
    var text = param.text;
    return(// @TODO : check if the style is correct
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
        className: "mindset-24 lg:mindset-40 text-primary-main inline-block",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ribbon_text_module_css__WEBPACK_IMPORTED_MODULE_2___default().ribbonText),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (RibbonText);


/***/ }),

/***/ 20846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ContentContainer = function(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _disableSpacing = param.disableSpacing, disableSpacing = _disableSpacing === void 0 ? false : _disableSpacing, className = param.className;
    var hasCustomBackground = backgroundColor.charAt(0) === "#" || backgroundColor.charAt(0) === "r";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(disableSpacing ? "" : "px-6 py-8 md:px-8 md:py-12", (backgroundColor === "gray" || backgroundColor === "grey") && "bg-background-default", backgroundColor === "white" && "bg-other-white", className),
        style: hasCustomBackground ? {
            backgroundColor: backgroundColor
        } : {},
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container mx-auto px-0",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Title = function(param) {
    var children = param.children, _align = param.align, align = _align === void 0 ? "center" : _align;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mindset-24 lg:mindset-40 text-text-primary pb-6 md:pb-12", align === "left" && "text-left", align === "center" && "text-center", align === "right" && "text-right"),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 21132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80969);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47533);
/* harmony import */ var api_marketingOptIn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99174);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9337);
/* harmony import */ var components_form_input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49868);
/* harmony import */ var hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44012);
/* harmony import */ var utils_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74372);
/* harmony import */ var validations_email__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42722);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74231);
















var CustomerIoLeadForm = function(param) {
    var title = param.title, subTitle = param.subTitle, leadEventName = param.leadEventName, buttonText = param.buttonText, formType = param.formType, _hideLegalText = param.hideLegalText, hideLegalText = _hideLegalText === void 0 ? false : _hideLegalText;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_6__.useState(false), 2), sent = ref[0], setSent = ref[1];
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().asPath;
    var currentUrl = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        return "".concat("https://www.petsdeli.de").concat(asPath.split("#")[0]);
    }, [
        asPath
    ]);
    var isMobile = (0,hooks_common_use_mobile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var validationSchema = yup__WEBPACK_IMPORTED_MODULE_9__/* .object */ .Ry({
        newsletter_email: validations_email__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
    });
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
        defaultValues: {
            newsletter_email: "",
            petType: undefined
        },
        mode: "onBlur",
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_13__/* .yupResolver */ .X)(validationSchema)
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, formState = ref1.formState;
    var onSubscribeDogsNewsletter = handleSubmit(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(data) {
            var newsletter_email, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newsletter_email = data.newsletter_email;
                        (0,utils_tracking__WEBPACK_IMPORTED_MODULE_7__/* .trackEvent */ .L9)(utils_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventName.NewsletterSignup */ .B_.NewsletterSignup);
                        _tmp = {};
                        return [
                            4,
                            (0,api_marketingOptIn__WEBPACK_IMPORTED_MODULE_1__/* .marketingOptIn */ ._)((_tmp.email = newsletter_email, _tmp.petType = "dog", _tmp.source = leadEventName, _tmp.opt_in_url = currentUrl, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        setSent(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    var onSubscribeCatsNewsletter = handleSubmit(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(data) {
            var newsletter_email, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newsletter_email = data.newsletter_email;
                        (0,utils_tracking__WEBPACK_IMPORTED_MODULE_7__/* .trackEvent */ .L9)(utils_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventName.NewsletterSignup */ .B_.NewsletterSignup);
                        _tmp = {};
                        return [
                            4,
                            (0,api_marketingOptIn__WEBPACK_IMPORTED_MODULE_1__/* .marketingOptIn */ ._)((_tmp.email = newsletter_email, _tmp.petType = "cat", _tmp.source = leadEventName, _tmp.opt_in_url = currentUrl, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        setSent(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-grey-100 pt-8 pb-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mindset-24 lg:mindset-40 text-primary-main text-center",
                    style: {
                        fontSize: isMobile ? "24px" : "40px"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mx-auto max-w-xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center font-medium",
                            children: subTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-4 flex flex-col items-center lg:flex-row",
                            children: sent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto text-center text-base font-medium md:text-lg",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    id: "footer:newsletter-thank-you",
                                    values: {
                                        br: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    }
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_form_input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        "aria-label": "E-Mail",
                                        className: "bg-other-white text-text-light-bg-secondary h-10 w-full rounded-sm border px-3 leading-none focus:outline-hidden",
                                        type: "email",
                                        name: "newsletter_email",
                                        register: register,
                                        placeholder: intl.formatMessage({
                                            id: "footer:newsletter-input-placeholder"
                                        }),
                                        formState: formState
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "-mx-2 flex",
                                        children: [
                                            (formType === "Both" || formType === "Dog") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full px-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    className: "w-full",
                                                    layout: "orange",
                                                    disabled: formState.isSubmitting,
                                                    onClick: onSubscribeDogsNewsletter,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "inline-block pr-1 text-lg",
                                                            style: {
                                                                transform: "translateY(1px)"
                                                            },
                                                            role: "img",
                                                            "aria-label": "F\xfcr Hunde",
                                                            children: "\uD83D\uDC36"
                                                        }),
                                                        " ",
                                                        buttonText
                                                    ]
                                                })
                                            }),
                                            (formType === "Both" || formType === "Cat") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full px-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    className: "w-full",
                                                    layout: "orange",
                                                    disabled: formState.isSubmitting,
                                                    onClick: onSubscribeCatsNewsletter,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "inline-block pr-1 text-lg",
                                                            style: {
                                                                transform: "translateY(1px)"
                                                            },
                                                            role: "img",
                                                            "aria-label": "F\xfcr Katzen",
                                                            children: "\uD83D\uDC31"
                                                        }),
                                                        " ",
                                                        buttonText
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    !hideLegalText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pt-4 leading-tight",
                                        style: {
                                            fontSize: "11px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            id: "footer:newsletter-unsubscribe-notice",
                                            values: {
                                                a: function(chunks) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/pages/".concat("datenschutz"),
                                                        className: "underline",
                                                        children: chunks
                                                    });
                                                },
                                                br: function() {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {});
                                                },
                                                strong: function(chunks) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                        children: chunks
                                                    });
                                                }
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerIoLeadForm);


/***/ }),

/***/ 31375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ faq_section; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(32924);
// EXTERNAL MODULE: ./src/components/lazy-motion-wrapper/index.tsx + 1 modules
var lazy_motion_wrapper = __webpack_require__(68656);
// EXTERNAL MODULE: ./src/components/markdown/index.tsx
var markdown = __webpack_require__(4015);
// EXTERNAL MODULE: ./src/assets/icons/minus.svg
var minus = __webpack_require__(75830);
// EXTERNAL MODULE: ./src/assets/icons/plus.svg
var plus = __webpack_require__(44448);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs
var motion_minimal = __webpack_require__(12560);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/tabs-accordeon-new/index.tsx






/**
 * Generic accordeon component
 */ var TabsAccordeonNew = function(param) {
    var id = param.id, isOpen = param.isOpen, onClick = param.onClick, title = param.title, content = param.content, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-controls": id,
                "aria-selected": isOpen ? "true" : "false",
                className: classnames_default()("flex  w-full items-center justify-between border-b border-grey-100 py-3 text-left first:border-t hover:text-other-black focus:outline-hidden "),
                "data-test": id,
                id: id,
                onClick: onClick,
                role: "tab",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.span, {
                        className: "flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-grey-100 text-text-primary",
                        animate: {
                            rotate: isOpen ? 0 : 180
                        },
                        transition: {
                            duration: 0.5
                        },
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(minus/* default */.Z, {
                            className: "w-3"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {
                            className: "w-3"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-labelledby": id,
                className: classnames_default()("border-b border-grey-100 focus:outline-hidden", isOpen ? "block" : "hidden"),
                "data-test": id,
                id: "".concat(id, "-tab"),
                role: "tabpanel",
                tabIndex: index,
                children: content
            })
        ]
    });
};
/* harmony default export */ var tabs_accordeon_new = (TabsAccordeonNew);

// EXTERNAL MODULE: ./src/modules/content-cms/util/render-document.tsx + 4 modules
var render_document = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-schemaorg/dist/src/index.js
var src = __webpack_require__(45363);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/faq-section/index.tsx











var FaqSection = function(param) {
    var faqs = param.faqs, onClickCallback = param.onClickCallback;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), openQuestion = ref[0], setOpenQuestion = ref[1];
    var extractAnswer = function(answer) {
        var mappedAnswer = [];
        answer.forEach(function(item) {
            mappedAnswer.push((0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)(item));
        });
        return mappedAnswer.join("");
    };
    var generateFaqMainEntity = function(faqs) {
        var schema = [];
        faqs.forEach(function(item) {
            schema.push({
                "@type": "Question",
                name: item.fields.title,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: extractAnswer(item.fields.bodyText.content)
                }
            });
        });
        return schema;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", (0,_object_spread/* default */.Z)({}, (0,src/* jsonLdScriptProps */.h6)({
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    mainEntity: generateFaqMainEntity(faqs)
                })))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_motion_wrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: faqs.map(function(faq, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_accordeon_new, {
                            id: faq.sys.id,
                            index: index,
                            isOpen: openQuestion === index,
                            onClick: function() {
                                setOpenQuestion(openQuestion === index ? null : index);
                                onClickCallback && onClickCallback({
                                    faq: faq,
                                    index: index
                                });
                            },
                            title: faq.fields.title,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(markdown/* default */.Z, {
                                children: (0,render_document/* default */.Z)(faq.fields.bodyText)
                            })
                        }, faq.sys.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var faq_section = (FaqSection);


/***/ }),

/***/ 61447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_content_cms_components_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40009);
/* harmony import */ var modules_content_cms_components_ribbon_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90200);
/* harmony import */ var modules_landingpage_components_collection_section_bestseller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38105);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_content_container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20846);
/* harmony import */ var _components_title__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(528);







var ProductSlider = function(param) {
    var title = param.title, backgroundColor = param.backgroundColor, collectionHandle = param.collectionHandle, isBlogPost = param.isBlogPost, itemSize = param.itemSize, richTitle = param.richTitle;
    var shopifyCollectionMap = (0,modules_content_cms_components_context__WEBPACK_IMPORTED_MODULE_1__/* .useContentful */ .G)().shopifyCollectionMap;
    if (!shopifyCollectionMap[collectionHandle]) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_content_container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        backgroundColor: backgroundColor ? backgroundColor : "white",
        children: [
            richTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_content_cms_components_ribbon_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                text: richTitle
            }) : title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_title__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: title
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_landingpage_components_collection_section_bestseller__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                isBlogPost: isBlogPost,
                collection: collectionHandle,
                staticCollection: shopifyCollectionMap[collectionHandle],
                itemSize: itemSize
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductSlider);


/***/ }),

/***/ 8918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/play-button.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgPlayButton(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM9 18V6l10 6-10 6z"
  })));
}
/* harmony default export */ var play_button = (SvgPlayButton);
// EXTERNAL MODULE: ./src/modules/content-cms/components/ribbon-text/index.tsx
var ribbon_text = __webpack_require__(90200);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/content-container/index.tsx
var content_container = __webpack_require__(20846);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/title/index.tsx
var components_title = __webpack_require__(528);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/video/video.module.css
var video_module = __webpack_require__(34984);
var video_module_default = /*#__PURE__*/__webpack_require__.n(video_module);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/video/index.tsx









var Video = function(param) {
    var title = param.title, hideTitle = param.hideTitle, subTitle = param.subTitle, backgroundColor = param.backgroundColor, videoId = param.videoId, disableSpacing = param.disableSpacing, richTitle = param.richTitle;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), clicked = ref[0], setClicked = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(content_container/* default */.Z, {
        disableSpacing: disableSpacing,
        backgroundColor: backgroundColor,
        children: [
            richTitle ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ribbon_text/* default */.Z, {
                        text: richTitle
                    }),
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center text-sm font-black uppercase leading-loose text-primary-main",
                        children: subTitle
                    })
                ]
            }) : title && hideTitle !== true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center text-sm font-black uppercase leading-loose text-primary-main",
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_title/* default */.Z, {
                        children: title
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto w-full max-w-4xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (video_module_default()).responsive,
                    children: clicked ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: "https://www.youtube-nocookie.com/embed/".concat(videoId, "?autoplay=1&rel=0"),
                        frameBorder: "0",
                        title: title,
                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            setClicked(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://i.ytimg.com/vi/".concat(videoId, "/hqdefault.jpg"),
                                layout: "fill",
                                alt: title,
                                objectFit: "cover",
                                objectPosition: "center"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute left-1/2 top-1/2 z-40 -ml-10 -mt-10 text-text-dark-bg-contrast-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(play_button, {
                                    className: "h-20 w-20 rounded-full shadow-xl"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var video = (Video);


/***/ }),

/***/ 4967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ render_document; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@ninetailed/experience.js-next/index.esm.js + 3 modules
var index_esm = __webpack_require__(30941);
// EXTERNAL MODULE: ./src/components/button-new/index.tsx
var button_new = __webpack_require__(76712);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/collapsible-text/index.tsx



/**
 * A component that displays text in a collapsible format, showing a preview
 * with a configurable number of words before allowing expansion
 */ var CollapsibleText = function(param) {
    var text = param.text, _previewWordCount = param.previewWordCount, previewWordCount = _previewWordCount === void 0 ? 11 : _previewWordCount;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var words = text.split(" ");
    var shouldCollapse = words.length > previewWordCount;
    var previewText = words.slice(0, previewWordCount).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mr-2 whitespace-pre-wrap",
                children: shouldCollapse && !isExpanded ? "".concat(previewText, "...") : text
            }),
            shouldCollapse && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_new/* default */.Z, {
                size: "xs",
                layout: "text",
                onClick: function() {
                    return setIsExpanded(!isExpanded);
                },
                className: "!w-auto",
                "data-test": "collapsible-text-toggle",
                children: isExpanded ? "Weniger Infos" : "Mehr Infos"
            })
        ]
    });
};
/* harmony default export */ var collapsible_text = (CollapsibleText);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/components/image/index.tsx
var components_image = __webpack_require__(10472);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/blog-image/index.tsx




var BlogImage = function(props) {
    var title = props.title, image = props.image, showTitle = props.showTitle, link = props.link, linkTarget = props.linkTarget, mobileImage = props.mobileImage;
    var responsiveImage = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, mobileImage))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: mobileImage && "hidden sm:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, image))
            })
        ]
    });
    if (link) return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            target: linkTarget,
            className: "flex flex-col place-content-center",
            children: [
                responsiveImage,
                showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "my-2 text-center text-primary-main",
                    children: title
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col place-content-center",
        children: [
            responsiveImage,
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "my-2 text-center",
                children: title
            })
        ]
    });
};
/* harmony default export */ var blog_image = (BlogImage);

// EXTERNAL MODULE: ./src/assets/icons/chevron-right-stroke.svg
var chevron_right_stroke = __webpack_require__(30372);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/modules/content-cms/sections/blog-section-cta/index.tsx







var BlogSectionCta = function(props) {
    var image = props.image, relatedArticleTitle = props.relatedArticleTitle, relatedArticleUrl = props.relatedArticleUrl, linkTarget = props.linkTarget, sectionTitle = props.sectionTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: relatedArticleUrl,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "mb-4 flex w-full no-underline!",
            target: linkTarget,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-2/4 lg:w-1/4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                        layout: "fill",
                        objectFit: "cover",
                        className: "rounded-l-md"
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full items-center justify-between rounded-r-md bg-[#F1C40F] px-2 text-lg text-primary-main lg:py-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-black uppercase",
                                    children: sectionTitle !== null && sectionTitle !== void 0 ? sectionTitle : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "magazine:article-page:section-cta:default-title"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-1!",
                                    children: relatedArticleTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right_stroke/* default */.Z, {
                            className: "h-6 w-6 shrink-0 "
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var blog_section_cta = (BlogSectionCta);

// EXTERNAL MODULE: ./src/modules/content-cms/sections/customer-io-lead-form/index.tsx
var customer_io_lead_form = __webpack_require__(21132);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/faq-section/index.tsx + 1 modules
var faq_section = __webpack_require__(31375);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/product-slider/index.tsx
var product_slider = __webpack_require__(61447);
// EXTERNAL MODULE: ./src/modules/content-cms/sections/video/index.tsx + 1 modules
var video = __webpack_require__(8918);
;// CONCATENATED MODULE: ./src/modules/content-cms/util/process-collapsible-text.ts



/**
 * Process a Contentful document to handle CollapsibleText tags that may span multiple paragraphs.
 * This function identifies paragraphs with CollapsibleText tags, combines content that spans multiple paragraphs,
 * and marks processed paragraphs appropriately.
 *It returns a processed document with CollapsibleText content merged and marked
 */ var processCollapsibleText = function(document) {
    // Create a deep copy to avoid mutating the original
    var processedDocument = JSON.parse(JSON.stringify(document));
    if (processedDocument.content && processedDocument.content.length > 0) {
        var inCollapsibleText = false;
        var collapsibleContent = "";
        var collapsibleStartIndex = -1;
        var previewWordCount;
        // Find CollapsibleText spans across paragraphs
        for(var i = 0; i < processedDocument.content.length; i++){
            var node = processedDocument.content[i];
            if (node.nodeType === dist.BLOCKS.PARAGRAPH && node.content && node.content.length > 0) {
                // Get the text content of this paragraph
                var paragraphText = node.content.filter(function(item) {
                    return item.nodeType === "text";
                }).map(function(item) {
                    return item.value;
                }).join("");
                // Check for opening tag
                if (!inCollapsibleText && paragraphText.includes("<CollapsibleText")) {
                    inCollapsibleText = true;
                    collapsibleStartIndex = i;
                    // Extract preview word count if present
                    var previewMatch = paragraphText.match(/previewWordCount=(\d+)/);
                    if (previewMatch) {
                        previewWordCount = parseInt(previewMatch[1]);
                    }
                    // Get content after opening tag
                    var startTagIndex = paragraphText.indexOf("<CollapsibleText");
                    var openTagEnd = paragraphText.indexOf(">", startTagIndex) + 1;
                    var content = paragraphText.substring(openTagEnd);
                    collapsibleContent += content;
                } else if (inCollapsibleText && !paragraphText.includes("</CollapsibleText>")) {
                    var separator = "\\n\\n";
                    collapsibleContent += separator + paragraphText;
                } else if (inCollapsibleText && paragraphText.includes("</CollapsibleText>")) {
                    var closeTagStart = paragraphText.lastIndexOf("</CollapsibleText>");
                    var contentBeforeClose = paragraphText.substring(0, closeTagStart);
                    collapsibleContent += "\\n\\n" + contentBeforeClose;
                    // Mark the starting paragraph with the complete content
                    if (collapsibleStartIndex >= 0) {
                        processedDocument.content[collapsibleStartIndex].data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, processedDocument.content[collapsibleStartIndex].data), {
                            isCollapsibleText: true,
                            collapsibleContent: collapsibleContent.trim(),
                            previewWordCount: previewWordCount
                        });
                        // Mark paragraphs to be skipped (including this one)
                        for(var j = collapsibleStartIndex + 1; j <= i; j++){
                            processedDocument.content[j].data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, processedDocument.content[j].data), {
                                skipRendering: true
                            });
                        }
                    }
                    // Reset for next CollapsibleText
                    inCollapsibleText = false;
                    collapsibleContent = "";
                    collapsibleStartIndex = -1;
                    previewWordCount = undefined;
                }
            }
        }
    }
    return processedDocument;
};

// EXTERNAL MODULE: ./src/modules/content-cms/util/util.module.css
var util_module = __webpack_require__(6506);
var util_module_default = /*#__PURE__*/__webpack_require__.n(util_module);
;// CONCATENATED MODULE: ./src/modules/content-cms/util/render-document.tsx


















/**
 * Render a rich text document from Contentful.
 * The document can contain various types of content, like text, images, videos, etc.
 *  If a text node contains a newline character, it will be rendered as a line break.
 * @see https://github.com/contentful/rich-text/tree/8b31b855f758fd8f26a041270903eadd6ebe337f/packages/rich-text-react-renderer
 */ var renderDocument = function(richTextDocument) {
    // Process the document to handle CollapsibleText blocks spanning multiple paragraphs
    var processedDocument = processCollapsibleText(richTextDocument);
    var _obj;
    var renderOptions = {
        renderText: function(text) {
            // Handle normal text with line breaks
            return text.split("\n").reduce(function(children, textSegment, index) {
                return (0,_to_consumable_array/* default */.Z)(children).concat([
                    index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, index),
                    textSegment
                ]);
            }, []);
        },
        renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(node, children) {
            var ref, ref1;
            // Skip paragraphs marked for skipping
            if ((ref = node.data) === null || ref === void 0 ? void 0 : ref.skipRendering) return null;
            // If this is a processed CollapsibleText paragraph
            if ((ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.isCollapsibleText) {
                var content = node.data.collapsibleContent;
                // Process the content to replace \\n\\n with actual newlines
                var processedContent = content.replace(/\\n\\n/g, "\n\n");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(collapsible_text, {
                    text: processedContent,
                    previewWordCount: node.data.previewWordCount
                });
            }
            // Handle regular paragraphs
            if (node.content.length === 1 && node.content[0].nodeType === "text" && node.content[0].value.includes("\n")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: children
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.EMBEDDED_ENTRY, function(node) {
            if (node.data.target.sys.contentType.sys.id === "nt_mergetag") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MergeTag */.ex, {
                    id: node.data.target.fields.id
                });
            } else if (node.data.target.sys.contentType.sys.id === "sectionFaQs") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_section/* default */.Z, (0,_object_spread/* default */.Z)({}, node.data.target.fields));
            }
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.EMBEDDED_ASSET, function(node) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* default */.Z, (0,_object_spread/* default */.Z)({}, node.data.target));
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.EMBEDDED_ENTRY, function(node) {
            if (node.data.target.sys.contentType.sys.id === "sectionProductSlider") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_slider/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, node.data.target.fields), {
                    isBlogPost: true
                }));
            } else if (node.data.target.sys.contentType.sys.id === "sectionFaQs") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-10 pt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_section/* default */.Z, (0,_object_spread/* default */.Z)({}, node.data.target.fields))
                });
            } else if (node.data.target.sys.contentType.sys.id === "sectionVideo") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, node.data.target.fields), {
                    disableSpacing: true
                }));
            } else if (node.data.target.sys.contentType.sys.id === "blogArticleImage") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_image, (0,_object_spread/* default */.Z)({}, node.data.target.fields));
            } else if (node.data.target.sys.contentType.sys.id === "blogSectionCta") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_section_cta, (0,_object_spread/* default */.Z)({}, node.data.target.fields));
            } else if (node.data.target.sys.contentType.sys.id === "sectionCustomerIoLeadForm") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_io_lead_form/* default */.Z, (0,_object_spread/* default */.Z)({}, node.data.target.fields));
            }
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_1, function(node, children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_2, function(node, children) {
            var props = {};
            if (node.content[0].nodeType === "text") props["id"] = node.content[0].value;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: children
            }));
        }), _obj)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (util_module_default()).normalize,
            "data-test": "rich-text-content",
            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(processedDocument, renderOptions)
        })
    });
};
/* harmony default export */ var render_document = (renderDocument);


/***/ }),

/***/ 56710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26725);
/* harmony import */ var modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52352);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45363);








var Active;
(function(Active) {
    Active[Active["main"] = 0] = "main";
    Active[Active["sub"] = 1] = "sub";
    Active[Active["blog"] = 2] = "blog";
    Active[Active["author"] = 3] = "author";
})(Active || (Active = {}));
var BreadcrumbListItem = function(param) {
    var href = param.href, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, text = param.text;
    if (isActive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
            className: "inline",
            children: [
                "",
                " / ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-grey",
                    children: text
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: "text-primary-main/50 hover:text-primary-main/100 inline cursor-pointer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                children: [
                    " ",
                    "/ ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hover:underline",
                        children: text
                    })
                ]
            })
        })
    });
};
var Breadcrumb = function(param) {
    var mainCategory = param.mainCategory, subCategory = param.subCategory, blogPost = param.blogPost, author = param.author, root = param.root;
    var activeItem;
    if (mainCategory) {
        activeItem = Active.main;
    }
    if (subCategory) {
        activeItem = Active.sub;
    }
    if (blogPost) {
        activeItem = Active.blog;
    }
    if (author) {
        activeItem = Active.author;
    }
    var generateBreadcrumbList = function(mainCategory, subCategory, blogPost, author) {
        var items = [
            {
                "@type": "ListItem",
                position: 1,
                name: "Magazin",
                item: (0,modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__/* .getMagazineUrl */ .il)(undefined, true)
            }, 
        ];
        if (mainCategory) {
            items.push({
                "@type": "ListItem",
                position: 2,
                name: "".concat(mainCategory.pageTitle),
                item: (0,modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__/* .getMagazineUrl */ .il)({
                    mainCategory: mainCategory
                }, true)
            });
        }
        if (mainCategory && subCategory) {
            items.push({
                "@type": "ListItem",
                position: 3,
                name: "".concat(subCategory.pageTitle),
                item: (0,modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__/* .getMagazineUrl */ .il)({
                    mainCategory: mainCategory,
                    subCategory: subCategory
                }, true)
            });
        }
        if (mainCategory && subCategory && blogPost) {
            items.push({
                "@type": "ListItem",
                position: 4,
                name: "".concat(blogPost.pageTitle),
                item: (0,modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__/* .getMagazineUrl */ .il)({
                    mainCategory: mainCategory,
                    subCategory: subCategory,
                    blogPost: blogPost
                }, true)
            });
            if (author) {
                items.push({
                    "@type": "ListItem",
                    position: 5,
                    name: "".concat(author.name),
                    item: (0,modules_magazine_util__WEBPACK_IMPORTED_MODULE_2__/* .getMagazineUrl */ .il)({
                        author: author
                    }, true)
                });
            }
        }
        return items;
    };
    // TODO : Pt-2470 Implementing breadcrumbs schema for PD magazine
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .jsonLdScriptProps */ .h6)({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    itemListElement: generateBreadcrumbList(mainCategory, subCategory, blogPost, author)
                })))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "font-black",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                    children: [
                        root && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "text-primary-main/50 hover:text-primary-main/100 inline cursor-pointer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "hover:underline",
                                            children: root
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbListItem, {
                                    href: "/".concat(modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__/* .magazineBathPath */ .K),
                                    isActive: true,
                                    text: "Magazin"
                                })
                            ]
                        }),
                        !root && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "text-primary-main/50 hover:text-primary-main/100 inline cursor-pointer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/magazin",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "hover:underline",
                                    children: "Magazin"
                                })
                            })
                        }),
                        mainCategory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbListItem, {
                                    href: "/".concat(modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__/* .magazineBathPath */ .K, "/").concat(mainCategory.handle),
                                    isActive: activeItem === Active.main,
                                    text: mainCategory.name
                                }),
                                subCategory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbListItem, {
                                            href: "/".concat(modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__/* .magazineBathPath */ .K, "/").concat(mainCategory.handle, "/").concat(subCategory.handle),
                                            isActive: activeItem === Active.sub,
                                            text: subCategory.name
                                        }),
                                        blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbListItem, {
                                            href: "/".concat(modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__/* .magazineBathPath */ .K, "/").concat(mainCategory.handle, "/").concat(subCategory.handle, "/").concat(blogPost.handle),
                                            isActive: activeItem === Active.blog,
                                            text: blogPost.title
                                        })
                                    ]
                                })
                            ]
                        }),
                        author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BreadcrumbListItem, {
                            href: "/".concat(modules_magazine_constants__WEBPACK_IMPORTED_MODULE_1__/* .magazineBathPath */ .K, "/author/").concat(author.handle),
                            isActive: activeItem === Active.author,
                            text: author.name
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);


/***/ }),

/***/ 26725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ magazineBathPath; }
/* harmony export */ });
/* unused harmony export pathConfig */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67573);
/* harmony import */ var constants_shop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72502);


var _obj;
/** Base path config for magazine  */ var pathConfig = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_shop__WEBPACK_IMPORTED_MODULE_0__/* .ShopId.DE */ .w.DE, "magazin"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, constants_shop__WEBPACK_IMPORTED_MODULE_0__/* .ShopId.CH */ .w.CH, "magazin"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "no-config", "no-config"), _obj);
/** Base path for magazine  */ var magazineBathPath = pathConfig["DE"];


/***/ }),

/***/ 52352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ nextPageQueryFactory; },
/* harmony export */   "il": function() { return /* binding */ getMagazineUrl; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42298);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70879);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26725);



/** Format date for magazine */ var formatDate = function(dateString) {
    try {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__["default"])(new Date(dateString), "dd.MM.yyyy", {
            locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        });
    } catch (error) {
        return null;
    }
};
/** Factory method for creating pagination query for Contentful*/ var nextPageQueryFactory = function(limit) {
    return function(pageNumber) {
        return {
            limit: limit,
            skip: limit * (pageNumber - 1)
        };
    };
};
/** Generate url or path for magazine path  */ var getMagazineUrl = function(urlConfig) {
    var /** if it's true, it returns full url domain */ fullUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var urlElements = [];
    if (fullUrl) {
        urlElements.push("".concat("https://www.petsdeli.de"));
    }
    urlElements.push("".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .magazineBathPath */ .K));
    if (urlConfig && "author" in urlConfig) {
        urlElements.push("author", "".concat(urlConfig.author.handle));
    } else if (urlConfig && "mainCategory" in urlConfig) {
        urlElements.push("".concat(urlConfig.mainCategory.handle));
        "subCategory" in urlConfig && urlElements.push("".concat(urlConfig.subCategory.handle));
        if ("blogPost" in urlConfig) {
            if (typeof urlConfig.blogPost !== "string") {
                urlElements.push("".concat(urlConfig.blogPost.handle));
            } else {
                urlElements.push("".concat(urlConfig.blogPost));
            }
        }
    }
    var rtnUrl = urlElements.join("/");
    // if full url is not intended, add '/' so that it's compatible to subpath
    if (!fullUrl) {
        rtnUrl = "/".concat(rtnUrl);
    }
    return rtnUrl;
};


/***/ }),

/***/ 42722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var emailValidationSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("required").email("email-is-valid");
/* harmony default export */ __webpack_exports__["Z"] = (emailValidationSchema);


/***/ }),

/***/ 49729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"markdown_root__KVb6w"};

/***/ }),

/***/ 30970:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ribbonText":"ribbon-text_ribbonText__EgT1W"};

/***/ }),

/***/ 34984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"responsive":"video_responsive__hTiCd"};

/***/ }),

/***/ 6506:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"normalize":"util_normalize__Re9kT"};

/***/ })

}]);